import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49e6e0d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","flex-direction":"row","width":"100%","padding":"20px"} }
const _hoisted_2 = { class: "line space-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "用户名", -1))
const _hoisted_4 = { class: "line space-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "联系邮箱", -1))
const _hoisted_6 = { class: "line space-between" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "注册时间", -1))
const _hoisted_8 = { class: "line space-between" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "账号等级", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "line space-between"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "到期时间", -1))
const _hoisted_14 = {
  class: "line",
  style: {"text-align":"right"}
}
const _hoisted_15 = {
  key: 0,
  style: {"max-width":"300px"}
}
const _hoisted_16 = { style: {"margin-bottom":"16px"} }
const _hoisted_17 = { style: {"margin-bottom":"16px"} }
const _hoisted_18 = { class: "line" }
const _hoisted_19 = {
  key: 1,
  style: {"max-width":"300px"}
}
const _hoisted_20 = { style: {"margin-bottom":"16px"} }

import ScPage from '@/components/common/page/ScPage.vue';
import { user } from '@/models/User';
import dayjs from 'dayjs';
import { computed, onMounted, reactive, ref } from 'vue';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { message, Modal } from 'ant-design-vue';
import { request } from '@/util/request';
import { tokenManager } from '@/util/token';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'User',
  setup(__props) {

const isVip = computed(
  () => user.data.user?.vipExpired && user.data.user.vipExpired > Date.now()
);
const activeKey = ref('changePassword');
const tabList = [
  {
    key: 'changePassword',
    tab: '修改密码',
  },
  {
    key: 'useCode',
    tab: '使用兑换码',
  },
];

const changePasswordForm = reactive({
  old: '',
  new: '',
  confirm: '',
});

async function changePassword() {
  if (changePasswordForm.new != changePasswordForm.confirm) {
    message.error('确认密码与新密码不一致');
    return;
  }
  const res = await request(
    '/management/user/changePassword',
    changePasswordForm
  );
  if (res) {
    Object.assign(changePasswordForm, {
      old: '',
      new: '',
      confirm: '',
    });
    message.success('修改成功');
  }
}

const codeForm = reactive({
  code: '',
});

async function useCode() {
  const res = await request('/management/user/useCode', codeForm);
  if (res) {
    console.log(res);
    user.set(res);
    Object.assign(codeForm, {
      code: '',
    });
    message.success('兑换成功成功');
  }
}

const setting = ref();
onMounted(async () => {
  const res = await request('/management/setting/get', { key: 'app' });
  if (res) {
    setting.value = res.value;
  }
});

const products = ref();
onMounted(async () => {
  const res = await request('/management/product/list');
  if (res) {
    products.value = res.list;
  }
});

const router = useRouter();

async function logout() {
  const confirm = await new Promise((resolve) => {
    Modal.confirm({
      title: '确定要退出登录吗',
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
  if (!confirm) {
    return;
  }
  const res = await request('/management/login/logout', null, {
    noNeedLogin: true,
  });
  if (res) {
    tokenManager.del();
    user.del();
    await router.push('/login');
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_unref(user).data.user)
    ? (_openBlock(), _createBlock(ScPage, {
        key: 0,
        title: "个人中心"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_a_card, {
              title: "个人信息",
              style: {"width":"400px","margin-right":"20px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("div", null, _toDisplayString(_unref(user).data.user.username), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", null, _toDisplayString(_unref(user).data.user.email), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(Number(_unref(user).data.user.createTime)).format(
                'YYYY-MM-DD HH:mm:ss'
              )), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  (isVip.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, "VIP用户"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, "普通用户"))
                ]),
                (isVip.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(Number(_unref(user).data.user.vipExpired)).format(
                'YYYY-MM-DD HH:mm:ss'
              )), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(ScBtn, {
                    type: "primary",
                    text: "退出登录",
                    handler: () => logout()
                  }, null, 8, ["handler"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_card, {
              style: {"flex-grow":"1"},
              "tab-list": tabList,
              "active-tab-key": activeKey.value,
              onTabChange: _cache[4] || (_cache[4] = (key) => (activeKey.value = key))
            }, {
              default: _withCtx(() => [
                (activeKey.value === 'changePassword')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_a_input_password, {
                          value: changePasswordForm.old,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((changePasswordForm.old) = $event)),
                          placeholder: "请输入原密码"
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_a_input_password, {
                          value: changePasswordForm.new,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((changePasswordForm.new) = $event)),
                          placeholder: "请输入新密码"
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_a_input_password, {
                          value: changePasswordForm.confirm,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((changePasswordForm.confirm) = $event)),
                          placeholder: "请确认新密码"
                        }, null, 8, ["value"])
                      ]),
                      _createVNode(ScBtn, {
                        handler: changePassword,
                        type: "primary",
                        text: "确定",
                        style: {"margin-top":"16px"}
                      })
                    ]))
                  : _createCommentVNode("", true),
                (activeKey.value === 'useCode')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_a_input, {
                          value: codeForm.code,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((codeForm.code) = $event)),
                          placeholder: "请输入兑换码"
                        }, null, 8, ["value"])
                      ]),
                      _createVNode(ScBtn, {
                        handler: useCode,
                        type: "primary",
                        text: "确定",
                        style: {"margin-top":"16px"}
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["active-tab-key"])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})